/*import Vue from 'vue'
import loadingComponent from './login.vue'

const LoadingConstructor = Vue.extend(loadingComponent)

const instance = new LoadingConstructor({
  el: document.createElement('div')
})
// 创建一个vue实例，挂载元素为新创建的div
/!*
let initLoadingInstance = function () {
  return new LoadingConstructor({
    el: document.createElement('div'),
  });
}
// 删除dom节点
let removeDom = (node) => {  if (node.parentNode) {
  node.parentNode.removeChild(node);
}
};
let instance = initLoadingInstance();
// 关闭loading
let closeLoading = () => {
  removeDom(instance.$el)
};
// 展示loading
let showLoading = function () {
  document.body.appendChild(instance.$el);
}
*!/
instance.show = false
let close = () =>{
  if(instance.show){instance.show = false}
}

let show = () =>{
  if(!instance.show){instance.show = true}
}
/!*const loading = {
  show() { // 显示方法
    instance.show = true
    document.body.appendChild(instance.$el)
  },
  hide() { // 隐藏方法
    instance.show = false
  }
}*!/

export default {
  /!* showLoading,
   closeLoading*!/
  show,
  close
}*/
import Vue from 'vue'
import loadingComponent from './index.vue'

const LoadingConstructor = Vue.extend(loadingComponent)

/*const instance = new LoadingConstructor({
  el: document.createElement('div')
})*/
// 创建一个vue实例，挂载元素为新创建的div
let initLoadingInstance = function () {
  return new LoadingConstructor({
    el: document.createElement('div'),
  });
}
// 删除dom节点
let removeDom = (node) => {  if (node.parentNode) {
  node.parentNode.removeChild(node);
}
};
let instance = initLoadingInstance();
// 关闭loading
let closeLoading = () => {
  removeDom(instance.$el)
};
// 展示loading
let showLoading = function () {
  document.body.appendChild(instance.$el);
}

export default {
   showLoading,
   closeLoading
}



// WEBPACK FOOTER //
// ./src/components/Loading/index.js